export const data = [
    {
        id: "0",
        question: "What was the main scoring method in 2020 FRC?",
        answer: "Shooting power cells into a power port.",
        variants: [`Leveling on a shield generator.`, `Shooting power cells into a power port.`, `Placing hatch panels and cargo onto a rocket.`, `Spinning a color wheel.`]
    },
    {
        id: "1",
        question: "What was the name of 2020's Game?",
        answer: "Infinite Recharge",
        variants: [`Infinite Recharge`, `Energy Recycle`, `Cheese Balls`, `Deep Skate`]
    },
    // {                            //game design consideration question
    //     id: "2",
    //     question: "",
    //     answer: "",
    //     variants: [``, ``, ``, ``]
    // },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },